import { render, staticRenderFns } from "./PerfisUsuarioStepDados.vue?vue&type=template&id=214e1acc&"
import script from "./PerfisUsuarioStepDados.vue?vue&type=script&lang=js&"
export * from "./PerfisUsuarioStepDados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports